// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + "datadog" + "." + "c57da36e228ddbf6cd2c" + ".js";
};